module.exports = __webpack_public_path__ + "img/backLog.b050bbe0.png";